var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIc3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 31,
    viewBox: "0 0 37 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.6412 10.3203L27.8912 0.320342C27.8032 0.219659 27.6946 0.138985 27.5728 0.0837378C27.451 0.0284902 27.3187 -5.15201e-05 27.185 2.96232e-05H9.68499C9.55183 -0.00102892 9.41997 0.0262932 9.29819 0.080177C9.17641 0.134061 9.06751 0.21327 8.97874 0.31253L0.228739 10.3125C0.07777 10.4869 -0.00362357 10.7108 0.000123873 10.9414C0.00387131 11.172 0.0924968 11.3932 0.249051 11.5625L17.749 30.3125C17.8368 30.4067 17.943 30.4818 18.061 30.5331C18.179 30.5845 18.3063 30.611 18.435 30.611C18.5637 30.611 18.691 30.5845 18.809 30.5331C18.927 30.4818 19.0332 30.4067 19.1209 30.3125L36.6209 11.5625C36.7753 11.3936 36.8626 11.1741 36.8664 10.9453C36.8701 10.7165 36.79 10.4942 36.6412 10.3203ZM10.3006 11.875L15.7069 25.3891L3.0928 11.875H10.3006ZM24.5506 11.875L18.435 27.1625L12.3194 11.875H24.5506ZM12.81 10L18.435 2.50003L24.06 10H12.81ZM26.5694 11.875H33.7772L21.1631 25.3891L26.5694 11.875ZM33.8694 10H26.4037L20.31 1.87503H26.76L33.8694 10ZM10.11 1.87503H16.56L10.4662 10H3.00061L10.11 1.87503Z",
    fill: "#012060"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc3);
export default __webpack_public_path__ + "static/media/ic3.074bb060aefe4f8d98a314da8ecb60d0.svg";
export { ForwardRef as ReactComponent };